import { WHATSAPP_NUMBER } from "../constants";
import { Icon } from "./Icon";

const WhatsAppButton = () => (
  <a
    href={`https://wa.me/${WHATSAPP_NUMBER}`}
    target="_blank"
    rel="noopener noreferrer"
    className="h-11 w-11 rounded-full bg-[#25D366] flex items-center justify-center text-white hover:bg-[#20BD5A] transition-colors"
  >
    {Icon.whatsapp}
  </a>
);

export default WhatsAppButton;